import { render } from "./settingindex.vue?vue&type=template&id=eb526e86&scoped=true"
import script from "./settingindex.vue?vue&type=script&lang=js"
export * from "./settingindex.vue?vue&type=script&lang=js"

import "./settingindex.vue?vue&type=style&index=0&id=eb526e86&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\bmac\\ims-web-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb526e86"]])

export default __exports__